import {
  IInvoice,
  ICheckoutCartOfferConditionInstallment,
  ICheckoutCartOfferPayment
} from '@/interfaces/Checkout';

import { EPaymentMethod } from '@/helpers/enums';
import { Payment } from './Payment';

export class Invoice implements IInvoice {
  paymentMethod: EPaymentMethod;
  paymentMethodInstallments: ICheckoutCartOfferConditionInstallment;
  paymentMethodAtSightAmount: number | string = 0;
  paymentMethodAtSightDiscountAmount: number | string = 0;
  paymentMethodAtSightDiscountPercentage: number | string = 0;

  originalAmount: number | string = 0;
  totalAmount: number | string = 0;
  creditAmount: any = 0;
  discountAmount: number | null = 0;
  discountPercentage: number | string | null = 0;

  constructor(payment_structure?: ICheckoutCartOfferPayment|void, payment?: Payment) {
    this.build(payment_structure, payment);
  }

  build(payment_structure?: ICheckoutCartOfferPayment|void, payment?: Payment): void {
    if (payment) {
      const structure = payment_structure;

      if (structure) {
        const selectedMethod = payment.selectedPaymentMethod;

        const paymentMethod: any = payment.getPaymentMethod(selectedMethod);
        const condition = structure.payment_conditions
          && structure.payment_conditions.find(condition => condition.payment_method_code == selectedMethod);

        this.creditAmount = structure!.credit_amount ? structure!.credit_amount : 0;

        const installments = condition && condition.installments && condition.installments.length
          ? condition.installments
          : [{number: 0, amount: 0}, {number: 0, amount: 0}];
        const firstInstallment = installments[0];
        const lastInstallment = installments[installments.length - 1];

        if (structure && firstInstallment && lastInstallment) {
          this.paymentMethod = selectedMethod;
          this.paymentMethodInstallments = {
            number: lastInstallment.number,
            amount: lastInstallment && lastInstallment.amount
          };

          this.paymentMethodAtSightAmount = firstInstallment && parseFloat(String((firstInstallment.amount) ? firstInstallment.amount : 0));
          this.paymentMethodAtSightDiscountPercentage = (paymentMethod && paymentMethod.discount_amount) ? paymentMethod.discount_amount : 0;
          this.originalAmount = structure && structure.cart_initial_price;
          this.discountAmount = structure && structure.global_discount_amount;
          this.totalAmount = structure && structure.cart_subtotal_price;
          this.discountPercentage = paymentMethod && paymentMethod.discount_percentage;
        }
      }
    }
  }
}
